import { styled } from 'goober';

export const BaseContainerStyle = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-right: max(env(safe-area-inset-right), 15px);
  padding-left: 15px;
  padding-left: max(env(safe-area-inset-left), 15px);
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  max-width: 1024px;
`;

export default BaseContainerStyle;
